"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Content = _interopRequireDefault(require("./components/Content"));

var _Anchor = _interopRequireDefault(require("./components/Anchor"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _useScroll = _interopRequireDefault(require("./useScroll"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);
/**
 * ContentBox
 */

var ContentBox = function ContentBox(_ref) {
  var children = _ref.children,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top' : _ref$placement,
      arrowOffset = _ref.arrowOffset,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      _ref$positionHorizont = _ref.positionHorizontal,
      positionHorizontal = _ref$positionHorizont === void 0 ? 'middle' : _ref$positionHorizont,
      _ref$positionVertical = _ref.positionVertical,
      positionVertical = _ref$positionVertical === void 0 ? 'center' : _ref$positionVertical,
      onOutsideClick = _ref.onOutsideClick,
      constraintToWindow = _ref.constraintToWindow,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["children", "placement", "arrowOffset", "open", "positionHorizontal", "positionVertical", "onOutsideClick", "constraintToWindow"]);
  var classes = useStyles();

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      positions = _useState2[0],
      setPositions = _useState2[1];

  var anchorRef = (0, _react.useRef)(null);

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      content = _useState4[0],
      setContent = _useState4[1];

  var childs = _react["default"].Children.map(children, function (child) {
    var _child$type, _child$type2;

    //@ts-ignore
    if (child && ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'ContentBox.Anchor') {
      return _react["default"].cloneElement(child, {
        ref: anchorRef
      });
    } // @ts-ignore


    if (child && ((_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === 'ContentBox.Content') {
      return _react["default"].cloneElement(child, _objectSpread({
        placement: placement,
        positions: positions,
        arrowOffset: arrowOffset,
        open: open,
        positionHorizontal: positionHorizontal,
        positionVertical: positionVertical,
        setContent: setContent,
        constraintToWindow: constraintToWindow
      }, rest));
    }

    return child;
  });

  var updateRef = (0, _react.useCallback)(function () {
    if (anchorRef.current && open && content) {
      var anchorRect = anchorRef.current.getBoundingClientRect();
      var contentRect = content.getBoundingClientRect();
      setPositions({
        anchor: anchorRect,
        box: contentRect
      });
    }
  }, [content, open]);
  (0, _useScroll["default"])(anchorRef.current, updateRef, 100);
  (0, _react.useEffect)(function () {
    updateRef();
  }, [updateRef]);
  (0, _react.useEffect)(function () {
    // eslint-disable-next-line complexity
    var handleClick = function handleClick(e) {
      if (content && open) {
        var _anchorRef$current;

        var isInside = (content === null || content === void 0 ? void 0 : content.contains(e.target)) || ((_anchorRef$current = anchorRef.current) === null || _anchorRef$current === void 0 ? void 0 : _anchorRef$current.contains(e.target));

        if (!isInside) {
          onOutsideClick === null || onOutsideClick === void 0 ? void 0 : onOutsideClick(e);
        }
      }
    };

    window.addEventListener('click', handleClick);
    return function () {
      return window.removeEventListener('click', handleClick);
    };
  }, [onOutsideClick, open, content]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.ContentBox
  }, childs);
};

exports["default"] = ContentBox;
ContentBox.Anchor = _Anchor["default"];
ContentBox.Content = _Content["default"];
//# sourceMappingURL=index.js.map